<template>
<div class="container" style="margin: 10px auto 80px auto; padding-bottom: 80px;">	    
    <div class="row border-bottom pb-2">  
        <div class="col">
            <h3 class="display-5">
                <i class="text-danger fas" :class="{'fa-calendar-day': !loading && !downloading, 'fa-circle-notch fa-spin': loading || downloading || loading1}"></i> 
                e-Receipts by {{receiptsBy}}                
                <button v-if="!editing" type="button" class="mt-3 btn btn-primary float-end" data-bs-toggle="modal" data-backdrop="static" data-bs-target="#modalSearch"><i class="fas fa-search"></i> Search e-Receipts by email</button> 
                <button v-if="editing == 'byDate'" type="button" class="mt-3 btn btn-primary float-end" v-on:click.self="editing = false; $router.back()"><i class="fas fa-arrow-left"></i> Go back</button>                
                <button v-if="editing == 'byReceipt'" type="button" class="mt-3 btn btn-primary float-end" v-on:click.self="toReceipts()"><i class="fas fa-arrow-left"></i> Back to receipts</button>
            </h3>
        </div>                 
    </div>   
    <transition name="default" mode="out-in">
        <div v-if="!editing" key="calendar">
            <div v-if="!loading" class="row mt-3" :class="{'editing': editing}">
                <calendar :data="events"></calendar>     
            </div>
        </div>        
        <div v-if="editing == 'byDate'" key="review">                
            <div class="row">        
                <div class="col-8">
                    <h3 class="mt-2 mb-2">e-Receipts for {{receiptsFor}}</h3>
                </div>
                <div class="col-4 pt-2">
                     <div class="btn-group float-end" role="group">
                        <button id="download" type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-download"></i> Download
                        </button>
                        <div class="dropdown-menu" aria-labelledby="download">
                            <a class="dropdown-item" v-on:click.prevent="downloadAll('B')" href="#">Bouncebacks</a>
                            <a class="dropdown-item" v-on:click.prevent="downloadAll('U')" href="#">Undeliverable</a>                            
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="row border-bottom mb-2 pb-2">
                <div class="col-12">
                    <div class="form-group mb-2">                        
                        <div class="row">
                            <div class="col-auto pt-1">
                                <label for="selectStatus">Mark all receipts on this page as</label>
                            </div>
                            <div class="col-auto">
                                <select :disabled="!paginatedData.length" class="form-select ms-2 me-2" v-model="pageReviewStatus" id="selectStatus">
                                    <option value="">Select a status</option>
                                    <option value="N">Not reviewed</option>
                                    <option value="Y">Reviewed, deliver e-receipt</option>
                                    <option value="D">Reviewed, no-ereceipt</option>
                                    <option value="E">E-receipt sent</option>
                                    <option value="U">Reviewed, undeliverable</option>
                                </select>
                            </div>
                            <div class="col-auto">
                                <button type="button" :disabled="pageReviewStatus == ''" class="btn btn-success" v-on:click="setPageReviewed()">Ok</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">                
                    <div class="form-check form-switch">
                        <input :disabled="loading || loading1" type="checkbox" class="form-check-input" id="specialHandling" v-model="filterSpecialHandling">
                        <label class="form-check-label" for="specialHandling">Show transactions with special handling</label>
                    </div>
                </div>                            
                <!--<div class="col">                
                    <div class="form-check form-switch">
                        <input :disabled="loading || loading1" type="checkbox" class="form-check-input" id="pledgeBalance" v-model="filterPledgeBalance">
                        <label class="form-check-label" for="pledgeBalance">Show transactions with negative pledge balances</label>
                    </div>
                </div>   -->
            </div>                  
            <div v-if="!loading && !loading1">
                <div v-if="paginatedData.length">
                    <div :key="x" class="card mt-2 mb-2" v-for="(receipt, x) in paginatedData">                                         
                        <div class="card-header" :class="{'bg-primary text-white': receipt.REVIEWED == 'Y', 'bg-info text-white': receipt.REVIEWED == 'D', 'bg-success text-white': receipt.REVIEWED == 'E', 'bg-danger text-white': receipt.REVIEWED == 'B', 'bg-warning': receipt.REVIEWED == 'U'}">
                            <!-- collapse header, donor name and amount -->
                            <div class="float-start">                        
                                <span class="mb-0" data-bs-toggle="collapse" :data-bs-target="'#collapse-'+receipt.RECEIPT_ID" :aria-controls="'collapse-'+receipt.RECEIPT_ID">
                                    <strong class="receipt-title vertical-fix">{{receipt.ENTITY_NAME}}: {{receipt.DONOR_ID}}</strong>	
                                    <div style="font-weight: normal; font-size: 0.8rem;" v-if="receipt.REVIEWED == 'B'"><i class="fas fa-exclamation-circle text-white"></i> This e-receipt could not be delivered</div>							
                                </span>
                            </div>
                            <div class="float-end">	
                                <div class="btn-group">
                                    <button :id="'bg'+x" type="button" class="btn btn-sm btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span v-if="receipt.REVIEWED == 'Y'">Reviewed, deliver e-receipt</span>
                                        <span v-else-if="receipt.REVIEWED == 'D'">Reviewed, no e-receipt</span>
                                        <span v-else-if="receipt.REVIEWED == 'E' || receipt.REVIEWED == 'B'">E-receipt sent</span>
                                        <span v-else-if="receipt.REVIEWED == 'U'">Reviewed, undeliverable</span>
                                        <span v-else>Not reviewed</span>
                                    </button>
                                    <div class="dropdown-menu-right dropdown-menu" :aria-labelledby="'bg'+x">
                                        <a class="dropdown-item text-secondary" v-if="receipt.REVIEWED != 'N'" v-on:click.prevent="setReviewed(receipt, 'N')"><i class="fas fa-times"></i> Not reviewed</a>
                                        <a class="dropdown-item text-primary" v-if="receipt.REVIEWED != 'Y'" v-on:click.prevent="setReviewed(receipt, 'Y')"><i class="fas fa-envelope"></i> Reviewed, deliver e-receipt</a>
                                        <a class="dropdown-item text-info" v-if="receipt.REVIEWED != 'D'" v-on:click.prevent="setReviewed(receipt, 'D')"><i class="fas fa-check"></i> Reviewed, no e-receipt</a>                                
                                        <a class="dropdown-item text-success" v-if="receipt.REVIEWED != 'E'" v-on:click.prevent="setReviewed(receipt, 'E')"><i class="fas fa-envelope-open-text"></i> E-receipt sent</a>  
                                        <a class="dropdown-item text-warning" v-if="receipt.REVIEWED != 'U'" v-on:click.prevent="setReviewed(receipt, 'U')"><i class="fas fa-ban"></i> Reviewed, undeliverable</a>  
                                    </div>
                                </div>	
                            </div>
                        </div>                
                        <div class="receipt collapse container-fluid p-2" :id="'collapse-'+receipt.RECEIPT_ID">
                            <div :key="y" class="row mb-2" v-for="(revision, y) in receipt.REVISIONS">
                                <div class="col-12 mb-0">
                                    <h6 class="text-white clearfix p-2 mb-0" :class="{'bg-info': revision.RECEIPT_DOCUMENT_SEQ == receipt.CURRENT_ID, 'bg-dark': revision.RECEIPT_DOCUMENT_SEQ != receipt.CURRENT_ID}">
                                        <div class="float-start">                        
                                            <strong class="mb-0" data-bs-toggle="collapse" :data-bs-target="'#docseq-'+revision.RECEIPT_DOCUMENT_SEQ" :aria-controls="'docseq-'+revision.RECEIPT_DOCUMENT_SEQ">
                                                <div class="pt-1 revision-title">{{revision.LABEL}}
                                                    <div class="pt-1 ms-1" v-if="revision.NOTES"><i class="fas fa-sticky-note"></i> <em>{{revision.NOTES}}</em></div>
                                                </div>
                                            </strong>
                                        </div>
                                        <div class="float-end">		
                                            <div class="text-end">
                                                <div class="btn-group">
                                                    <button :id="'group'+y" type="button" v-on:click="currentRevision = revision;" class="btn btn-sm btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        Actions
                                                    </button>
                                                    <div class="dropdown-menu-right dropdown-menu" :aria-labelledby="'group'+y">
                                                        <a class="dropdown-item text-primary" v-on:click="currentRevision = revision; currentReceipt = receipt; editing = 'byReceipt'"><i class="fas fa-edit"></i> Edit</a>
                                                        <a class="dropdown-item text-warning" v-if="receipt.CURRENT_ID != revision.RECEIPT_DOCUMENT_SEQ" v-on:click.prevent="updateRevision(revision, receipt, 'setCurrent')" href="#"><i class="fas fa-check"></i> Set current revision</a>
                                                        <a class="dropdown-item text-danger" v-if="revision.RECEIPT_DOCUMENT_SEQ != receipt.ORIGINAL_ID" v-on:click.prevent="revision.deleting = true;" href="#"><i class="fas fa-times"></i> Delete revision</a>                                                
                                                    </div>
                                                </div>                                                                                                                                                                           
                                                <div class="mt-2" v-if="revision.deleting">
                                                    <strong>Are you sure?</strong>                                                            
                                                    <button type="button" v-on:click="updateRevision(revision, receipt, 'delete')" class="ms-2 me-2 btn btn-sm btn-success">Yes</button>
                                                    <button type="button" v-on:click="revision.deleting = false" class="btn btn-sm btn-danger">No</button>
                                                </div>
                                            </div>  
                                        </div>
                                    </h6>
                                </div>
                                <div class="collapse col-12" :id="'docseq-'+revision.RECEIPT_DOCUMENT_SEQ" :class="{'show': revision.RECEIPT_DOCUMENT_SEQ == receipt.CURRENT_ID}">
                                    <div class="row">
                                        <div class="col-6 border-end pe-0">                            
                                            <h6 class="bg-secondary text-white clearfix section-header">
                                                <span class="vertical-fix">Donor information</span>
                                            </h6>
                                            <div class="container-fluid detail border-start">                                        
                                                <div class="row">
                                                    <div class="col-4 bg-light">Name</div>
                                                    <div class="col">{{revision.RECEIPT_DATA.labelLine1}}</div>
                                                </div>		
                                                <div class="row">
                                                    <div class="col-4 bg-light">Advance ID</div>
                                                    <div class="col">{{revision.RECEIPT_DATA.idNumber}}</div>
                                                </div>		
                                                <div v-if="revision.RECEIPT_DATA.address.home[0] != null" class="row">
                                                    <div class="col-4 bg-light">Home address</div>
                                                    <div class="col-8">
                                                        <div :key="hh" v-for="(h, hh) in revision.RECEIPT_DATA.address.home.filter(hr => {return hr > ' '})">{{h}}</div>											
                                                    </div>
                                                </div>		
                                                <div v-if="revision.RECEIPT_DATA.address.business[0] != null" class="row">
                                                    <div class="col-4 bg-light">Business address</div>
                                                    <div class="col-8">
                                                        <div :key="bb" v-for="(b, bb) in revision.RECEIPT_DATA.address.business.filter(bu => {return bu > ' '})">{{b}}</div>											
                                                    </div>
                                                </div>		
                                                <div class="row">
                                                    <div class="col-4 bg-light">Telephone</div>
                                                    <div class="col-8">
                                                        <div :key="pp" v-for="(p, pp) in revision.RECEIPT_DATA.phone">
                                                            {{p}}
                                                        </div>
                                                    </div>
                                                </div>		
                                                <div class="row">
                                                    <div class="col-4 bg-light">Email</div>
                                                    <div class="col">{{revision.RECEIPT_DATA.email}}</div>									
                                                </div>
                                                <div class="row">
                                                    <div class="col-4 bg-light border-bottom">Matching company</div>
                                                    <div class="col border-bottom">{{revision.RECEIPT_DATA.claimCompanyName1}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 ps-0">
                                            <h6 class="bg-secondary text-white clearfix section-header">
                                                <div class="float-start">
                                                    <span class="vertical-fix">Gift information</span>
                                                </div>
                                                <div class="float-end">                                                    
                                                    <div v-if="(revision.RECEIPT_DATA.allocations || []).length == 1">                                                            
                                                        <button type="button" :disabled="downloading" v-on:click="downloadRevision(revision.RECEIPT_DATA, false, 'docx')" class="btn btn-sm btn-primary me-2"><i class="fas fa-file-word"></i> Receipt .docx</button>
                                                        <button type="button" :disabled="downloading" v-on:click="downloadRevision(revision.RECEIPT_DATA, false, 'pdf')" class="btn btn-sm btn-danger"><i class="fas fa-file-pdf"></i> Receipt .pdf</button>
                                                    </div>
                                                    <div v-else>
                                                        <button type="button" :disabled="downloading" v-on:click="downloadRevision(revision.RECEIPT_DATA, false, 'docx')" class="btn btn-sm btn-primary me-2"><i class="fas fa-file-word"></i> Combined .docx</button>
                                                        <button type="button" :disabled="downloading" v-on:click="downloadRevision(revision.RECEIPT_DATA, false, 'pdf')" class="btn btn-sm btn-danger"><i class="fas fa-file-pdf"></i> Combined .pdf</button>
                                                    </div>
                                                </div>
                                            </h6>                                            
                                            <div :key="k" class="container-fluid detail border-end" v-for="(allocation, k) in revision.RECEIPT_DATA.allocations">                                        
                                                <div class="row">
                                                    <div class="col border-top clearfix">
                                                        <div class="float-start">
                                                            <strong class="vertical-fix">Receipt {{allocation.receiptNumber}}</strong>                                        
                                                        </div>
                                                        <div class="float-end" v-if="(revision.RECEIPT_DATA.allocations || []).length > 1">
                                                            <button type="button" :disabled="downloading" v-on:click="downloadRevision(revision.RECEIPT_DATA, allocation, 'docx')" class="btn btn-sm btn-primary me-2"><i class="fas fa-file-word"></i> {{allocation.receiptNumber}} .docx</button>
                                                            <button type="button" :disabled="downloading" v-on:click="downloadRevision(revision.RECEIPT_DATA, allocation, 'pdf')" class="btn btn-sm btn-danger"><i class="fas fa-file-pdf"></i> {{allocation.receiptNumber}} .pdf</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4 bg-light">Allocation</div>
                                                    <div class="col">{{allocation.allocationName}} ({{allocation.allocationCode}})</div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4 bg-light">Amount</div>
                                                    <div class="col">{{allocation.giftAmount | currency}}</div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4 bg-light">Gift date</div>
                                                    <div class="col">{{allocation.dateOfRecordNice}}</div>
                                                </div>		                        		
                                                <div v-if="allocation.pledgePayment == 'Y'">
                                                    <div class="row">
                                                        <div class="col-4 bg-light">Pledge amount</div>
                                                        <div class="col">{{allocation.pledgeAmount | currency}}</div>
                                                    </div>		
                                                    <!--<div class="row">
                                                        <div class="col-4 bg-light">Pledge balance</div>
                                                        <div class="col">{{allocation.pledgeBalanceAmount | currency}}</div>
                                                    </div>		-->
                                                </div>
                                                <div class="row" v-if="allocation.specialHandling != null">
                                                    <div class="col-4 bg-light">Special handling</div>
                                                    <div class="col">{{allocation.specialHandlingDescription}}</div>
                                                </div>
                                                <div class="row" v-if="allocation.giftInKindDescription != null">
                                                    <div class="col-4 bg-light">In-kind detail</div>
                                                    <div class="col">{{allocation.giftInKindDescription}}</div>                                    
                                                </div>
                                                <div class="row" v-if="allocation.securitiesDescription != null">
                                                    <div class="col-4 bg-light">Securities detail</div>
                                                    <div class="col-8">
                                                        <div>{{allocation.securitiesDescription}}</div>
                                                        <div>{{allocation.securitiesAmount}}</div>
                                                    </div>
                                                </div>		                               
                                                <div class="row">
                                                    <div class="col-4 border-bottom bg-light">Transaction type</div>
                                                    <div class="col border-bottom">{{displayTxnType(allocation)}}</div>                                    
                                                </div>		
                                            </div>
                                        </div>
                                    </div>                            
                                </div>
                            </div>
                        </div>
                    </div>     
                </div>
                <div v-else>
                    <h4>No receipts match your criteria</h4>
                </div>
            </div>                     

            <div v-if="filteredReceipts.length" class="row">
                <div class="col-3">
                    <button class="btn btn-primary me-2" type="button" :disabled="pageNumber == 0" v-on:click="setPage(0)"><i class="fas fa-chevron-circle-left"></i> First</button>                    
                    <button class="btn btn-primary" type="button" :disabled="pageNumber == 0" v-on:click="prevPage()"><i class="fas fa-chevron-left"></i> Back</button>
                </div>
                <div class="col-6" style="text-align: center">
                    <h5 v-if="pageCount">page {{pageNumber + 1}} of {{pageCount}}</h5>
                </div>
                <div class="col-3">					
                    <button class="float-end btn btn-primary" type="button" :disabled="pageNumber == pageCount - 1 || !pageCount" v-on:click="setPage(pageCount - 1)">Last <i class="fas fa-chevron-circle-right"></i></button>                    
                    <button class="float-end btn btn-primary me-2" type="button" :disabled="pageNumber == pageCount - 1 || !pageCount" v-on:click="nextPage()">Forward <i class="fas fa-chevron-right"></i></button>					
                </div>
			</div>
        </div> 
        <div id="byReceipt" v-if="editing == 'byReceipt'">            
            <h3>Donor information</h3>
            <div class="row">                                  
                <div class="col-6">
                    <h4>Mailing label</h4>
                    <div class="form-label-group">
                        <input type="text" name="idNumber" class="form-control" v-model="donorData.RECEIPT_DATA.idNumber" placeholder="Donor ID Number" />
                        <label>Donor ID Number</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="labelLine1" class="form-control" v-model="donorData.RECEIPT_DATA.labelLine1" placeholder="Mailing label line 1" />
                        <label>Mailing label line 1</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="labelLine2" class="form-control" v-model="donorData.RECEIPT_DATA.labelLine2[0]" placeholder="Mailing label line 2" />
                        <label>Mailing label line 2</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="labelLine3" class="form-control" v-model="donorData.RECEIPT_DATA.labelLine2[1]" placeholder="Mailing label line 3" />
                        <label>Mailing label line 3</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="labelLine4" class="form-control" v-model="donorData.RECEIPT_DATA.labelLine2[2]" placeholder="Mailing label line 4" />
                        <label>Mailing label line 4</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="labelLine5" class="form-control" v-model="donorData.RECEIPT_DATA.labelLine2[3]" placeholder="Mailing label line 5" />
                        <label>Mailing label line 5</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="labelLine6" class="form-control" v-model="donorData.RECEIPT_DATA.labelLine2[4]" placeholder="Mailing label line 6" />
                        <label>Mailing label line 6</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="labelLine7" class="form-control" v-model="donorData.RECEIPT_DATA.labelLine2[5]" placeholder="Mailing label line 7" />
                        <label>Mailing label line 7</label>
                    </div>
                </div>
                <div class="col-6">
                    <h4>Email address</h4>
                    <div class="form-label-group">
                        <input type="text" name="email" class="form-control" v-model="donorData.RECEIPT_DATA.email" placeholder="Email address" />
                        <label>Email address</label>
                    </div>
                    <h4>Matching gift information</h4>
                    <div class="form-label-group">
                        <input type="text" name="matchingCompany" class="form-control" v-model="donorData.RECEIPT_DATA.claimCompanyName1" placeholder="Matching company" />
                        <label>Matching company</label>
                    </div>                    
                </div>
            </div>
            <div class="row mt-2 pt-2 border-top">
                <div class="col-6">
                    <h4>Home address</h4>
                    <div class="form-label-group">
                        <input type="text" name="homeStreet1" class="form-control" v-model="donorData.RECEIPT_DATA.address.home[0]" placeholder="Home address street 1" />
                        <label>Home address street 1</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="homeStreet2" class="form-control" v-model="donorData.RECEIPT_DATA.address.home[1]" placeholder="Home address street 2" />
                        <label>Home address street 2</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="homeStreet3" class="form-control" v-model="donorData.RECEIPT_DATA.address.home[2]" placeholder="Home address street 3" />
                        <label>Home address street 3</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="homeCityStateZip" class="form-control" v-model="donorData.RECEIPT_DATA.address.home[3]" placeholder="Home address city, state zip" />
                        <label>Home address city, state, zip</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="telephone" class="form-control" v-model="donorData.RECEIPT_DATA.phone[0]" placeholder="Home telephone number" />
                        <label>Home telephone number</label>
                    </div>
                </div>
                <div class="col-6">
                    <h4>Business address</h4>
                    <div class="form-label-group">
                        <input type="text" name="businessStreet1" class="form-control" v-model="donorData.RECEIPT_DATA.address.business[0]" placeholder="Business address street 1" />
                        <label>Business address street 1</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="businessStreet2" class="form-control" v-model="donorData.RECEIPT_DATA.address.business[1]" placeholder="Business address street 2" />
                        <label>Business address street 2</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="businessStreet3" class="form-control" v-model="donorData.RECEIPT_DATA.address.business[2]" placeholder="Business address street 3" />
                        <label>Business address street 3</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="businessCityStateZip" class="form-control" v-model="donorData.RECEIPT_DATA.address.business[3]" placeholder="Business address city, state zip" />
                        <label>Business address city, state, zip</label>
                    </div>
                    <div class="form-label-group">
                        <input type="text" name="telephone" class="form-control" v-model="donorData.RECEIPT_DATA.phone[1]" placeholder="Telephone number" />
                        <label>Business telephone number</label>
                    </div>
                </div>                        
            </div>
            <h3>Transaction information</h3>
            <div class="row">                        
                <div :key="k" class="col-12" v-for="(a, k) in donorData.RECEIPT_DATA.allocations">                               
                    <div class="row mb-2 pt-2 border-top">
                        <div class="col-8">
                            <h4>Receipt {{a.receiptNumber}}</h4>                                  
                        </div>
                        <div class="col-4 text-end">
                            <button type="button" class="btn btn-sm btn-info text-white" v-on:click="previewReceipt(a)"><i class="fas fa-file-word"></i> Preview allocation receipt</button>
                        </div>
                    </div>
                    <div class="row">   
                        <div class="col-4">                         
                            <div class="form-label-group">
                                <v-date-picker
                                  mode="single"
                                  v-model="a.dateOfRecordDate"                  
                                >
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="input-group form-label-group">
                                        <input type="text"
                                          class="form-control"                    
                                          :value="inputValue"
                                          v-on="inputEvents"
                                          placeholder="Date of record"
                                        >
                                        <label :class="{'populated': a.dateOfRecordDate > ''}">Date of record</label>                                         
                                    </div>
                                </template>
                                </v-date-picker>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-label-group">
                                <div class="form-label-group select">
                                    <select class="form-control" v-model="a.transactionType" v-on:change="updateTransactionType(a)">  
                                        <option :value="a.originalTransactionType">Gift or pledge payment</option>
                                        <option value="realized_bequest">Bequest</option>
                                        <option value="gift_ira">IRA gift</option>                                                                            
                                    </select>
                                    <label>Transaction type</label>									
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-label-group">
                                        <div class="form-label-group select">
                                            <select class="form-control" v-on:change="updatePledgePayment(a)" v-model="a.pledgePayment">                                                
                                                <option value="Y">Yes</option>
                                                <option value="N">No</option>
                                            </select>
                                            <label>Pledge payment?</label>									
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-if="a.pledgePayment == 'Y'">
                                    <div>
                                        <div class="input-group form-label-group">                                        
                                            <div class="input-group-text"><i class="fas fa-dollar-sign"></i></div>     
                                            <currency-input v-model="a.pledgeAmount" :options="{ currency: 'USD', currencyDisplay: 'hidden', precision: 2 }" id="pledgeAmount" title="Pledge amount" placeholder="Pledge amount" class="form-control" />                                                                                   
                                            <label>Pledge amount</label>
                                        </div>
                                    </div>
                                    <!--<div>
                                        <div class="input-group form-label-group">                                            
                                            <div class="input-group-text"><i class="fas fa-dollar-sign"></i></div>                                            
                                            <currency-input v-model="a.pledgeBalanceAmount" :options="{ currency: 'USD', currencyDisplay: 'hidden', precision: 2 }" id="pledgeBalance" title="Pledge balance" placeholder="Pledge balance" class="form-control" />                                       
                                            <label>Pledge balance</label>
                                        </div>
                                    </div>-->
                                </div>
                            </div>                                    
                        </div>
                    </div>
                    <div class="row">   
                        <div class="col-3">
                            <div class="input-group form-label-group">
                                <div class="input-group-text"><i class="fas fa-dollar-sign"></i></div>
                                <currency-input v-model="a.giftAmount" :options="{ currency: 'USD', currencyDisplay: 'hidden', precision: 2 }" id="amount" title="Amount" placeholder="Amount" class="form-control" />                                                                       
                                <label>Amount</label>                                                        
                            </div> 

                        </div>
                        <div class="col-9">
                            <div class="form-label-group input-group">
                                <input type="text" disabled="true" class="form-control disabled" :value="a.allocationName" placeholder="Allocation" />
                                <label>Gift allocation</label>
                                <button type="button" v-on:click="currentAllocation = k" class="btn btn-success" data-bs-toggle="modal" data-backdrop="static" data-bs-target="#modalAllocationSelect"><i class="fas fa-fw fa-mouse-pointer"></i></button>											                                
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="form-label-group">
                                <div class="form-label-group select">
                                    <select v-on:change="updateSpecialHandling(a)" class="form-select" v-model="a.specialHandling">                                        
                                        <option value="H">In honor of</option>
                                        <option value="M">In memory of</option>
                                        <option value="S">In support of</option>
                                    </select>
                                    <label>Special handling type</label>									
                                </div>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="form-label-group">
                                <input title="Special handling description" v-model="a.specialHandlingDescription" placeholder="Special handling description" class="form-control" />
                                <label>Special handling description</label>		                           
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="form-label-group">
                                <div class="form-label-group select">
                                    <select :disabled="a.transactionType == 'gift_ira'" v-on:change="updatePaymentType(a)" class="form-select" v-model="a.paymentType">
                                        <option :value="a.originalPaymentType">Cash/check/other</option>
                                        <option value="gik">Gift-in-kind</option>
                                        <option value="stock">Securities gift</option>                                        
                                    </select>
                                    <label>Payment type</label>									
                                </div>
                            </div>
                        </div>
                        <div class="col-8" v-if="a.paymentType == 'gik'">
                            <div class="form-label-group">
                                <input title="Gift in kind description" v-model="a.giftInKindDescription" placeholder="Gift in kind description" class="form-control"/>
                                <label>Gift in kind description</label>
                            </div>
                        </div>
                        <div class="col-8" v-if="a.paymentType == 'stock'">
                            <div class="form-label-group">
                                <input title="Securities amount" v-model="a.securitiesAmount" placeholder="Securities amount" class="form-control"/>
                                <label>Securities amount</label>
                            </div>
                            <div class="form-label-group">
                                <input title="Securities description" v-model="a.securitiesDescription" placeholder="Securities description" class="form-control"/>
                                <label>Securities description</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row border-top pt-2">                
                <div class="col-12">
                    <div class="form-label-group">
                        <input title="Revision title" v-model="donorData.LABEL" placeholder="Revision title *" class="form-control" :class="{'border-danger': donorData.LABEL.trim() == ''}"/>
                        <label>Revision title *</label>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-label-group">
                        <textarea title="Revision notes" v-model="donorData.NOTES" placeholder="Revision notes" class="form-control"></textarea>    
                        <label>Revision notes</label>
                    </div>
                </div>                
            </div>
            <div class="row border-top pt-2">                
                <div class="col">
                    <button type="button" class="btn btn-info text-white me-2" v-on:click="previewReceipt(false)"><i class="fas fa-file-word"></i> Preview combined receipt</button>
                    <button type="button" class="btn btn-success" :disabled="donorData.LABEL.trim() == '' || saving" v-on:click="saveReceipt()">
                        <span v-if="!saving"><i class="fas fa-save"></i> Save all changes</span>
                        <span v-else><i class="fas fa-circle-notch fa-spin"></i> Saving...</span>
                    </button>
                </div>                
            </div>
        </div>       
    </transition>
    <!--<doc-upload></doc-upload>    -->
    <allocation-select></allocation-select>
    <search></search>
</div>
</template>
<script>
import calendar from './ereceipt/calendar.vue';
import search from './ereceipt/search.vue';
import allocationSelect from './ereceipt/allocation.select.vue';
import currencyInput from './common/currencyInput.vue';
import { Collapse } from 'bootstrap';
export default {
    components: {
        calendar: calendar,        
        search: search,
        allocationSelect: allocationSelect,
        currencyInput: currencyInput
    },
    data() {
        return {                    
            downloading: false,
            loading: false,
            loading1: false,
            editing: false,
            saving: false,
            events: [],
            receipts: [],
            receiptsOriginal: [],
            receiptKey: 0,                       
            size: 8,
			pageNumber: 0,   
            currentPage: [],         
            currentReceipt: null,
            currentRevision: null,
            currentAllocation: 0,
            donorData: {RECEIPT_ID: '', NOTES: '', LABEL: '', RECEIPT_DATA: {labelLine2: [], phone: [], address: {home: [], business: []}, allocations: [{allocationCode: '', paymentType: '', originalPaymentType: '', originalTransactionType: '', flag: {}}]}},
            originalReceipt: {},
            receiptDate: '',            
            pageReviewStatus: '',
            paymentType: [                
                {value: 'gik', display: 'Gift-in-kind'},
                {value: 'stock', display: 'Securities gift'}                
            ],            
            transactionType: [
                {value: 'gift', display: 'Straight gift'},
                {value: 'realized_bequest', display: 'Bequest'},
                {value: 'gift_ira', display: 'IRA gift'}            
            ],
            allAllocations: [],
            filterSpecialHandling: false,
            filterPledgeBalance: false
        }
    },
    beforeRouteEnter (to, from, next) {        
        next(vm => {       
            var sd = vm.$route.params.startDate || null;
            var ed = vm.$route.params.endDate || null;
            if (vm.$route.params.type) {
                vm.getDocs(vm.$route.params.type, vm.$route.params.param, sd, ed);                  
            } else {
                vm.eReceiptLookup();
                vm.editing = false;
            }
            vm.loading = true;
            //Fetch the allocation lookup promise
            vm.allocationLookup()
            .then(response => {								
				if (response.data.error) {
                    vm.$root.setAlert(true, response.data.error, 'alert-danger');
                    vm.loading = false;
					return;
				} else {
                    //Set allocations before the route finishes
                    vm.allAllocations = response.data;                    
                    vm.loading = false;
				}
    		}).catch(error => {
                vm.$root.setAlert(true, error, 'alert-danger');
                vm.loading = false;
				return;
    		})  
        }); 
    },
    methods: {    
        downloadRevision: function(receiptData, allocation = false, output = 'docx') {   
            this.downloading = true;
            var data = JSON.parse(JSON.stringify(receiptData));   
            if (allocation !== false) { //Unset allocations, add only specified one if variable is populated
                data.allocations = [];
                data.allocations[0] = JSON.parse(JSON.stringify(allocation));
            }
            var _this = this; 
            var action = "preview-combined";
            var filename = data.idNumber+'-'+data.allocations[0].dateOfRecord+'.'+output;
            var formData = new FormData();
            formData.append("type", 'ERECEIPT');                        
            formData.append("ereceiptAction", action);
            formData.append("output", output);
            formData.append("receiptData", JSON.stringify(data));
            this.axios({
                method: 'post',
                url: this.$config[process.env.VUE_APP_ENV].app.base+'data/php/receipt.generate.php',
                responseType: 'blob',
                data: formData
            }).then(function (response) {	   
                if (response.data.type == 'text/html') {
                    var d = new Blob([response.data]);
                    var r = new FileReader();
                    r.addEventListener('loadend', (e) => {
                        const err = e.srcElement.result;
                        _this.$root.setAlert(true, err, 'alert-danger');
                    });
                    r.readAsText(d);   
                    _this.downloading = false;                                                         
					return;
                }                                        		
				if (response.data.error) {
                    _this.$root.setAlert(true, response.data.error, 'alert-danger');                    
                    _this.downloading = false;
					return;
				} else {                       
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
					link.remove();     
                    _this.downloading = false;               	        
				}                      																				                                
            });    
        },
        toCalendar: function() {
            this.editing = false;
            this.$router.push({ name: 'ereceipt'});
        },
        toReceipts: function() {
            this.editing = 'byDate';
            location.reload();   
        },
        parseReceiptData: function(data) {            
            //Update dates                         
            for (var i = 0; i < data.allocations.length; i++) {                
                var dor = new Date(data.allocations[i].dateOfRecordDate);
                var mm = dor.getMonth() + 1;
                var dd = dor.getDate();
                var month = dor.toLocaleString('default', { month: 'long' });
                var yyyy = dor.getFullYear();
                data.allocations[i].dateOfRecord = [yyyy, (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('');
                data.allocations[i].dateOfRecordNice = month + ' ' + dd + ', ' + yyyy;
                data.allocations[i].processedMonth = mm.toString();  
                if (data.allocations[i].giftAmount != null) {
                    data.allocations[i].giftAmount = parseFloat(data.allocations[i].giftAmount.toString().replace(/,/g, ""));    
                }              
                data.allocations[i].taxDeductibleAmount = data.allocations[i].giftAmount;
                if (data.allocations[i].pledgeAmount != null) {
                    data.allocations[i].pledgeAmount = parseFloat(data.allocations[i].pledgeAmount.toString().replace(/,/g, ""));
                }
                if (data.allocations[i].specialHandling == null) {
                    data.allocations[i].specialHandling = '';
                }
                /*if (data.allocations[i].pledgeBalanceAmount != null) {
                    data.allocations[i].pledgeBalanceAmount = parseFloat(data.allocations[i].pledgeBalanceAmount.toString().replace(/,/g, ""));                      
                }*/
            }                
            return data;
        },
        saveReceipt: function() {
            this.saving = true;
            var data = JSON.parse(JSON.stringify(this.donorData.RECEIPT_DATA));
            data = this.parseReceiptData(data);            
            var ereceiptDonorData = {
                'receiptId': this.donorData.RECEIPT_ID,
                'label': this.donorData.LABEL,
                'note': this.donorData.NOTES
            };
            //Create combined receipt                      
            var formData = new FormData();
            formData.append("type", 'ERECEIPT');
            formData.append("ereceiptAction", "update");  
            formData.append("ereceiptDonorData", JSON.stringify(ereceiptDonorData));          
            formData.append("donor", data.idNumber);   
            formData.append("receiptData", JSON.stringify(data));
            var _this = this;
            this.axios({
                method: 'post',
                url: this.$config[process.env.VUE_APP_ENV].app.base+'data/php/receipt.generate.php',
                data: formData
            }).then(function (response) {	
                _this.saving = false;
                _this.toReceipts();
                _this.revisionsLookup(_this.currentReceipt);
            });                                    
        },   
        previewReceipt: function(allocation) {            
            var data = JSON.parse(JSON.stringify(this.donorData.RECEIPT_DATA));   
            var _this = this; 
            var action = "preview-combined";
            if (allocation !== false) {                
                var filename = 'preview-'+allocation.receiptNumber+'.docx';
                action = "preview-individual";
                data.allocations = [];
                data.allocations.push(allocation);
            } else {                
                var filename = 'preview-'+data.idNumber+'-'+data.allocations[0].dateOfRecord+'-combined.docx';
            }
            data = this.parseReceiptData(data);                
            var formData = new FormData();
            formData.append("type", 'ERECEIPT');                        
            formData.append("ereceiptAction", action);
            formData.append("receiptData", JSON.stringify(data));
            this.axios({
                method: 'post',
                url: this.$config[process.env.VUE_APP_ENV].app.base+'data/php/receipt.generate.php',
                responseType: 'blob',
                data: formData
            }).then(function (response) {	   
                if (response.data.type == 'text/html') {
                    var d = new Blob([response.data]);
                    var r = new FileReader();
                    r.addEventListener('loadend', (e) => {
                        const err = e.srcElement.result;
                        _this.$root.setAlert(true, err, 'alert-danger');
                    });
                    r.readAsText(d);                                                            
					return;
                }                                        		
				if (response.data.error) {
                    _this.$root.setAlert(true, response.data.error, 'alert-danger');                    
					return;
				} else {                       
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
					link.remove();                    	        
				}                      																				                                
            });  
        },        
        updatePledgePayment: function(allocation) {
            delete(allocation.flag.pledgePayment);                                 
            if (allocation.pledgePayment == 'Y') {
                allocation.flag.pledgePayment = true;
            }
        },
        updatePaymentType: function(allocation) {
            delete(allocation.flag.securities);                                 
            delete(allocation.flag.giftInKind);
            switch(allocation.paymentType) {
                case 'gik':
                    allocation.flag.giftInKind = true;
                break;
                case 'stock':
                    allocation.flag.securities = true;
                break;
                /*case 'A':
                    allocation.transactionType = 'IR';
                    this.updateTransactionType(allocation);
                break;*/
                default:
                break;                
            }
        },
        updateTransactionType: function(allocation) {
            delete(allocation.flag.IRA);
            delete(allocation.flag.bequest);
            switch (allocation.transactionType) {
                case "realized_bequest":
                    allocation.flag.bequest = true;                    
                break;
                case "gift_ira":
                    allocation.flag.IRA = true;
                    //allocation.paymentType = 'A';                    
                break;                
                default:
                    allocation.paymentType = allocation.originalPaymentType;
                break;
            }
        },
        updateSpecialHandling: function(allocation) {
            switch (allocation.specialHandling) {
                case "H":
                    allocation.specialHandlingDescription = "In honor of ";
                    allocation.flag.specialHandling = true;                                        
                break;
                case "M":
                    allocation.specialHandlingDescription = "In memory of ";
                    allocation.flag.specialHandling = true;
                break;
                case "S":
                    allocation.specialHandlingDescription = "In support of ";
                    allocation.flag.specialHandling = true;
                break;
                default:
                    allocation.specialHandlingDescription = "";
                    delete(allocation.flag.specialHandling);
                break;
            }
        },
        displayTxnType: function(receipt) {
            var out = 'Straight gift';
            if (receipt.pledgePayment == 'Y') {
                out = 'Pledge payment';
            } else {
                var pt = this.paymentType.filter(p => {
                    return p.value == receipt.paymentType;
                });
                if (pt.length) {
                    out = pt[0].display;
                }
                var tt = this.transactionType.filter(t => {
                    return t.value == receipt.transactionType;
                });
                if (tt.length) {
                    out = tt[0].display;
                }
            }
            return out;
        },
        updateRevision: function(revision, receipt, action) {
            var params = {
                'action': action,
                'receiptId': receipt.RECEIPT_ID,         
                'sequence': revision.RECEIPT_DOCUMENT_SEQ
            };                
            this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/ereceipt/revision.update.php', {
                params: params 
            }).then(response => {	                                           		                
				if (response.data.error) {
					this.$root.setAlert(true, response.data.error, 'alert-danger');
					return;
				} else {  
                    switch (action) {
                        case 'delete':
                            receipt.CURRENT_ID = receipt.ORIGINAL_ID;
                            receipt.REVISIONS = receipt.REVISIONS.filter(r => {
                                return r.RECEIPT_DOCUMENT_SEQ != revision.RECEIPT_DOCUMENT_SEQ;
                            });
                        break;
                        case 'setCurrent':
                            receipt.CURRENT_ID = revision.RECEIPT_DOCUMENT_SEQ;
                        break;
                    }                                      
				}
    		}).catch(error => {
				this.$root.setAlert(true, error, 'alert-danger');
				return;
    		});
               
        },     
        setPageReviewed: function() {
            for (var i = 0; i < this.paginatedData.length; i++) {
                this.setReviewed(this.paginatedData[i], this.pageReviewStatus);                
            }            
            this.pageReviewStatus = '';
        },   
        setReviewed: function(receipt, status) {            
             this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/ereceipt/receipt.review.php', {
                params: {                    
                    'receiptId': receipt.RECEIPT_ID,         
                    'status': status
                }
            }).then(response => {	                        		                
				if (response.data.error) {
					this.$root.setAlert(true, response.data.error, 'alert-danger');
					return;
				} else {    
                    this.events = [];                
                    this.eReceiptLookup();
				}
    		}).catch(error => {
				this.$root.setAlert(true, error, 'alert-danger');
				return;
    		});        
            receipt.REVIEWED = status;
        },        
        dateModifiedNice: function(date) {            
            const d = new Date(date.replace(/-/g, '\/') + 'T00:00:00');
            return d.toLocaleString('en-US', {month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', second: '2-digit'});
        },
        pmtType: function(type) {
            return this.paymentType.filter(t => {
                return t.value == type;
            })[0].display;
        },   
        nextPage: function() {
			if (this.pageNumber < this.pageCount) {
				this.pageNumber++;				
				this.switchPage();			
			}
		},
		prevPage: function() {
			if (this.pageNumber > 0) {
				this.pageNumber--;
				this.switchPage();
			}
		},
		setPage: function(p) {
			this.pageNumber = p;
			this.switchPage();
		},
		switchPage: function() {	            
			var collapseElementList = [].slice.call(document.querySelectorAll(".receipt.collapse"));			
			collapseElementList.map(function (collapseEl) {
				var c = new Collapse(collapseEl, { toggle: false});
				c.hide();
			});									
		},
        downloadAll: function(type) {            
            var toDownload = this.receipts.filter(r => { return r.REVIEWED == type});
            var seqs = [];
            var filename = 'receipts';
            if (!toDownload.length) {
                this.$root.setAlert(true, 'There are no receipts with that status to download', 'alert-warning');
                return;
            }
            var docs = [];            
            for (var i = 0; i < toDownload.length; i++) {
                var r = toDownload[i].CURRENT_ID; 
                for (var j = 0; j < toDownload[i].REVISIONS.length; j++) {
                    if (toDownload[i].REVISIONS[j].RECEIPT_DOCUMENT_SEQ == r) {
                        seqs.push(toDownload[i].REVISIONS[j].DOCUMENTS.filter(d => {
                            return d.RECEIPT_TYPE == 'COMBINED';
                        })[0].RECEIPT_SEQUENCE);        
                    }
                }                             
            }     
            var formData = new FormData();			
            formData.append("sequence", seqs);
            formData.append("docType", 'docx');
            formData.append("review", true);
            switch (type) {
                case 'U':
                    filename = 'undeliverable';
                break;
                case 'B':
                    filename = 'bouncebacks';
                break;
            }
            filename = filename + '-' + this.$route.params.param;
            this.doDocDownload(formData, filename);       
        },
        downloadDoc: function(revision, receiptNumber, type, docType) {                 
            var doc = {};
            switch (type) {
                case 'INDIVIDUAL':
                    doc = revision.DOCUMENTS.filter(d => {
                        return d.RECEIPT_NUMBER == receiptNumber;
                    })[0];
                break;
                case 'COMBINED':
                    doc = revision.DOCUMENTS.filter(d => {
                        return d.RECEIPT_TYPE == 'COMBINED';
                    })[0];
                break;
            }            
            var seq = doc.RECEIPT_SEQUENCE;
            var formData = new FormData();			
            formData.append("sequence", seq);
            formData.append("docType", docType);
            /*if (docType == "docx") { //This is causing issues for combined e-receipts that have different transaction types
                formData.append("review", true);
            }*/
            this.doDocDownload(formData, doc.FILENAME);
        },
        doDocDownload: function(formData, fileName) {     
            var _this = this;                            
            this.axios({
                method: 'post',
                url: this.$config[process.env.VUE_APP_ENV].app.base+'data/php/ereceipt/doc.download.php',
                responseType: 'blob',
                data: formData
            }).then(function (response) {	 
                if (response.data.type == 'text/html') {
                    var d = new Blob([response.data]);
                    var r = new FileReader();
                    r.addEventListener('loadend', (e) => {
                        const err = e.srcElement.result;
                        _this.$root.setAlert(true, err, 'alert-danger');
                    });
                    r.readAsText(d);                                                            
					return;
                }                                        		
				if (response.data.error) {
                    _this.$root.setAlert(true, response.data.error, 'alert-danger');                    
					return;
				} else {                       
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName+'.'+formData.get('docType'));
                    document.body.appendChild(link);
                    link.click();
					link.remove();                    	        
				}                  
            });
        },
        allocationLookup: function() {
			return this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/ereceipt/allocation.lookup.php');			
        },
        revisionsLookup: function(receipt) {
            var _this = this;			
			this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/ereceipt/revisions.lookup.php', {
                params: {
                    receiptId: receipt.RECEIPT_ID
                }
            }).then(response => {		
				if (response.data.error) {
                    _this.$root.setAlert(true, response.data.error, 'alert-danger');                    
                    return;
				}		 
                                                               
				for (var i = 0; i < response.data.length; i++) {                    
                    for (var j = 0; j < response.data[i].REVISIONS.length; j++) {                                                    
                        response.data[i].REVISIONS[j].RECEIPT_DATA = JSON.parse(response.data[i].REVISIONS[j].RECEIPT_DATA);
                        this.$set(response.data[i].REVISIONS[j], 'deleting', false);
                        this.$set(response.data[i].REVISIONS[j], 'RECEIPT_ID', response.data[i].RECEIPT_ID);                                                   
                        var alloc = [];
                        if (response.data[i].REVISIONS[j].RECEIPT_DATA.allocations && response.data[i].REVISIONS[j].RECEIPT_DATA.allocations.length > 0) {
                            for (var a = 0; a < response.data[i].REVISIONS[j].RECEIPT_DATA.allocations.length; a++) {
                                alloc.push(response.data[i].REVISIONS[j].RECEIPT_DATA.allocations[a]);
                            }                                                        
                        }                        
                        response.data[i].REVISIONS[j].RECEIPT_DATA.allocations = [];                           
                        if (response.data[i].REVISIONS[j].RECEIPT_DATA.pledgePayment && response.data[i].REVISIONS[j].RECEIPT_DATA.pledgePayment.length > 0) {
                            for (var p = 0; p < response.data[i].REVISIONS[j].RECEIPT_DATA.pledgePayment.length; p++) {
                                alloc.push(response.data[i].REVISIONS[j].RECEIPT_DATA.pledgePayment[p]);
                            }                            
                            delete response.data[i].REVISIONS[j].RECEIPT_DATA['pledgePayment'];                            
                        }
                        if (response.data[i].REVISIONS[j].RECEIPT_DATA.securities && response.data[i].REVISIONS[j].RECEIPT_DATA.securities.length > 0) {
                            for (var s = 0; s < response.data[i].REVISIONS[j].RECEIPT_DATA.securities.length; s++) {
                                alloc.push(response.data[i].REVISIONS[j].RECEIPT_DATA.securities[s]);
                            }                            
                            delete response.data[i].REVISIONS[j].RECEIPT_DATA['securities'];
                        }
                        if (response.data[i].REVISIONS[j].RECEIPT_DATA.giftInKind && response.data[i].REVISIONS[j].RECEIPT_DATA.giftInKind.length > 0) {
                            for (var g = 0; g < response.data[i].REVISIONS[j].RECEIPT_DATA.giftInKind.length; g++) {
                                alloc.push(response.data[i].REVISIONS[j].RECEIPT_DATA.giftInKind[g]);
                            }                            
                            delete response.data[i].REVISIONS[j].RECEIPT_DATA['giftInKind'];                            
                        }                        
                        for (let a = 0; a < alloc.length; a++) {
                            response.data[i].REVISIONS[j].RECEIPT_DATA.allocations.push(alloc[a]);
                        }                        
                    }                                                         
                }  

                _this.currentReceipt.REVISIONS = response.data[0].REVISIONS;
                _this.currentReceipt.CURRENT_ID = response.data[0].CURRENT_ID;          
            }).catch(error => {
                _this.$root.setAlert(true, error, 'alert-danger');                
                return;
			});
        },      
        eReceiptLookup: function() {
			var _this = this;
			this.loading = true;
			this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/ereceipt/date.lookup.php').then(response => {		                                           
				if (response.data.error) {
                    _this.$root.setAlert(true, response.data.error, 'alert-danger');
                    _this.loading = false;
                    return;
				}		                
				for (var i = 0; i < response.data.length; i++) {
                    if (response.data[i].PENDING > 0) {
						_this.events.push({
							id: '0_pending_'+i,
							title: 'Not reviewed: '+response.data[i].PENDING,
							start: response.data[i].PROCESSED_DATE,
							className: ['border-secondary', 'bg-secondary', 'text-white'],
							data: {date: response.data[i].PROCESSED_DATE}						
						})	
					}
					if (response.data[i].REVIEWED > 0) {
						_this.events.push({
							id: '1_reviewed_'+i,
							title: 'Send e-receipt: '+response.data[i].REVIEWED,
							start: response.data[i].PROCESSED_DATE,							
							className: ['border-primary', 'bg-primary', 'text-white'],
							data: {date: response.data[i].PROCESSED_DATE}				
						})	
					}
                    if (response.data[i].NORECEIPT > 0) {
						_this.events.push({
							id: '2_noreceipt_'+i,
							title: 'Do not send: '+response.data[i].NORECEIPT,
							start: response.data[i].PROCESSED_DATE,							
							className: ['border-info', 'bg-info', 'text-white'],
							data: {date: response.data[i].PROCESSED_DATE}				
						})	
					}
                    if (response.data[i].EMAILED > 0) {
						_this.events.push({
							id: '3_emailed_'+i,
							title: 'E-receipt sent: '+response.data[i].EMAILED,
							start: response.data[i].PROCESSED_DATE,							
							className: ['border-success', 'bg-success', 'text-white'],
							data: {date: response.data[i].PROCESSED_DATE}				
						})	
                    }
                     if (response.data[i].BOUNCED > 0) {
						_this.events.push({
							id: '4_bounced_'+i,
							title: 'Bounceback: '+response.data[i].BOUNCED,
							start: response.data[i].PROCESSED_DATE,							
							className: ['border-danger', 'bg-danger', 'text-white'],
							data: {date: response.data[i].PROCESSED_DATE}				
						})	
					}
                     if (response.data[i].UNDELIVERABLE > 0) {
						_this.events.push({
							id: '5_undeliverable'+i,
							title: 'Undeliverable: '+response.data[i].UNDELIVERABLE,
							start: response.data[i].PROCESSED_DATE,							
							className: ['border-warning', 'bg-warning'],
							data: {date: response.data[i].PROCESSED_DATE}				
						})	
					}
				}
				_this.loading = false;                     
            }).catch(error => {                
                _this.$root.setAlert(true, error, 'alert-danger');
                _this.loading = false;
                return;
			});     
        },
        getDocs: function(type, param, startDate, endDate) {                      
            if (this.editing) {                
                return;
            }            
            this.editing = 'byDate';            
            this.loading = true;
            var _this = this;                
            this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/ereceipt/receipts.lookup.php', {
				params: {   
                    type: type,
                    param: param,
                    startDate: startDate,
                    endDate: endDate                                   
                }
			}).then(response => {	                                                             
				if (response.data.error) {
                    _this.$root.setAlert(true, response.data.error, 'alert-danger');
                    _this.loading = false;
                    return;
                }          
                this.receipts = [];                                     
				for (var i = 0; i < response.data.length; i++) {
                    for (var j = 0; j < response.data[i].REVISIONS.length; j++) {                                                    
                        response.data[i].REVISIONS[j].RECEIPT_DATA = JSON.parse(response.data[i].REVISIONS[j].RECEIPT_DATA);
                        this.$set(response.data[i].REVISIONS[j], 'deleting', false);
                        this.$set(response.data[i].REVISIONS[j], 'RECEIPT_ID', response.data[i].RECEIPT_ID);                                                   
                        var alloc = [];
                        if (response.data[i].REVISIONS[j].RECEIPT_DATA.allocations && response.data[i].REVISIONS[j].RECEIPT_DATA.allocations.length > 0) {
                            for (var a = 0; a < response.data[i].REVISIONS[j].RECEIPT_DATA.allocations.length; a++) {
                                alloc.push(response.data[i].REVISIONS[j].RECEIPT_DATA.allocations[a]);
                            }                                                        
                        }                        
                        response.data[i].REVISIONS[j].RECEIPT_DATA.allocations = [];                           
                        if (response.data[i].REVISIONS[j].RECEIPT_DATA.pledgePayment && response.data[i].REVISIONS[j].RECEIPT_DATA.pledgePayment.length > 0) {
                            for (var p = 0; p < response.data[i].REVISIONS[j].RECEIPT_DATA.pledgePayment.length; p++) {
                                alloc.push(response.data[i].REVISIONS[j].RECEIPT_DATA.pledgePayment[p]);
                            }                            
                            delete response.data[i].REVISIONS[j].RECEIPT_DATA['pledgePayment'];                            
                        }
                        if (response.data[i].REVISIONS[j].RECEIPT_DATA.securities && response.data[i].REVISIONS[j].RECEIPT_DATA.securities.length > 0) {
                            for (var s = 0; s < response.data[i].REVISIONS[j].RECEIPT_DATA.securities.length; s++) {
                                alloc.push(response.data[i].REVISIONS[j].RECEIPT_DATA.securities[s]);
                            }                            
                            delete response.data[i].REVISIONS[j].RECEIPT_DATA['securities'];
                        }
                        if (response.data[i].REVISIONS[j].RECEIPT_DATA.giftInKind && response.data[i].REVISIONS[j].RECEIPT_DATA.giftInKind.length > 0) {
                            for (var g = 0; g < response.data[i].REVISIONS[j].RECEIPT_DATA.giftInKind.length; g++) {
                                alloc.push(response.data[i].REVISIONS[j].RECEIPT_DATA.giftInKind[g]);
                            }                            
                            delete response.data[i].REVISIONS[j].RECEIPT_DATA['giftInKind'];                            
                        }                        
                        for (let a = 0; a < alloc.length; a++) {
                            response.data[i].REVISIONS[j].RECEIPT_DATA.allocations.push(alloc[a]);
                        }                        
                    }                                     
                    this.receipts.push(response.data[i]);                    
                }                      
				_this.loading = false;     
            }).catch(error => {              
                _this.$root.setAlert(true, error, 'alert-danger');
                _this.loading = false;
                return;
			});  
        }
    },
    watch: {        
        currentPage: function(newVal, oldVal) {               
            if (newVal.length == 0) {
                this.loading1 = true;
                if (this.filterPledgeBalance || this.filterSpecialHandling || (!this.receipts.length && !this.loading)) {   
                    this.loading1 = false;
                }
            } else {
                this.loading1 = false;
            }            
        },
        '$route.params.type': function(newVal, oldVal) {
            if (!newVal) {
                this.editing = false;
            } else {
                this.getDocs(newVal, this.$route.params.param);
            }
        },
        editing: function(newVal, oldVal) {
            if (newVal == 'byDate') {
                this.pageNumber = 0;
                this.receipts = [];
            }
        },        
        currentRevision: function(newVal, oldVal) {            
            this.donorData = JSON.parse(JSON.stringify(newVal));
            this.donorData.LABEL = '';
            this.donorData.NOTES = '';
            for (var i = 0; i < this.donorData.RECEIPT_DATA.allocations.length; i++) {
                var dor = this.donorData.RECEIPT_DATA.allocations[i].dateOfRecord;
                var y = parseInt(dor.substring(0,4));
                var m = parseInt(dor.substring(4,6) - 1);
                var d = parseInt(dor.substring(6,8));
                var dt = new Date(y, m, d);
                this.$set(this.donorData.RECEIPT_DATA.allocations[i], 'originalPaymentType', this.donorData.RECEIPT_DATA.allocations[i].paymentType);                
                this.$set(this.donorData.RECEIPT_DATA.allocations[i], 'originalTransactionType', this.donorData.RECEIPT_DATA.allocations[i].transactionType);  
                this.$set(this.donorData.RECEIPT_DATA.allocations[i], 'dateOfRecordDate', dt);
                if (this.donorData.RECEIPT_DATA.allocations[i].flag == undefined) {
                    this.$set(this.donorData.RECEIPT_DATA.allocations[i], 'flag', {});
                }
            }           
        }
    },
    computed: {
        filteredReceipts: function() {
            this.loading1 = true;
            var out = this.receipts;
            //if (this.filterPledgeBalance || this.filterSpecialHandling) {   
            if (this.filterSpecialHandling) {   
                out = [];
                this.switchPage();
                this.pageNumber = 0;         
                for (var i = 0; i < this.receipts.length; i++) {                    
                    var f = false;
                    for (var j = 0; j < this.receipts[i].REVISIONS.length; j++) {                          
                        var rec =  this.receipts[i].REVISIONS[j].RECEIPT_DATA.allocations.filter(r => {
                            return r.specialHandling > ' ';
                            /*if (this.filterPledgeBalance && this.filterSpecialHandling) {                            
                                return r.pledgePayment == 'Y' && r.pledgeBalanceAmount < 0 &&  r.specialHandling > ' ';
                            } else {
                                if (this.filterPledgeBalance) {                                
                                    return r.pledgePayment == 'Y' && r.pledgeBalanceAmount < 0;
                                } 
                                if (this.filterSpecialHandling) {
                                    return r.specialHandling > ' ';
                                }
                            }*/                            
                        });                             
                        if (rec.length > 0) {
                            f = true;
                        }
                    }
                    if (f) {
                        out.push(this.receipts[i]);
                    }
                } 
            }
            this.loading1 = false;
            return out;     
        },
        receiptsFor: function() {
            var out = '';            
            var t = this.$route.params.type;
            var p = this.$route.params.param;
            switch (t) {
                case 'date':                
                    var year = p.substring(0,4);
                    var month = p.substring(4,6);
                    var day = p.substring(6,8);
                    out = new Date(year, month-1, day).toLocaleString('en-US', {month: 'long', day: 'numeric', year: 'numeric'});                    
                break;
                default: 
                    out = p;
                break;
            }
            return out;
        },
        receiptsBy: function() {
            var out = 'Date';
            if (this.$route.params.type) {
                out = this.$route.params.type.charAt(0).toUpperCase() + this.$route.params.type.slice(1);
            }
            return out;
        },
        receiptUpdated: function() {
            return _.isEqual(this.donorData, this.originalReceipt);            
        },   
		pageCount: function() {
				let l = this.filteredReceipts.length;
				let s = this.size;
					var c = Math.floor(l/s);
				if (l % s > 0) {
					c++;
				}					
				return c;
		},
		paginatedData: function() {    
            if (this.pageNumber > this.pageCount) {                
                this.pageNumber = 0;
            }
            const start = this.pageNumber * this.size;            
            const end = start + this.size;
            this.currentPage = this.filteredReceipts.slice(start, end);	            			
            return this.currentPage;
		}
	},
    mounted () {
        this.eReceiptLookup();
    }
}
</script>
<style >
.fc-basic-view .fc-body .fc-row {
    min-height: 8em;
}

.fc-day-grid-event .fc-content {
    padding: 2px 4px;
    cursor: pointer;
}

.editing .fc-day-grid-event, .editing .fc-day-grid-event:active, .editing .fc-day-grid-event:hover {
    background-color: #CCC !important;
    color: #666  !important;
    border-color: #AAA  !important;
}

.default-enter-active, .default-leave-active {
  transition: all .3s ease;
}

.default-enter, .default-leave-to {
    opacity: 0;  
    transform: translateX(100px);
}

.default-leave, .default-enter-to {
    opacity: 1;
    transform: translateX(0);
}

.receipt-title, .revision-title, .dropdown-item {
    cursor: pointer;
}

.revision-title em {
    font-size: 0.8rem;
    font-weight: normal;
}

.detail {
    padding: 0rem 0.75rem !important;
}

.detail .row .col, .detail .row .col-4, .detail .row .col-8  {
    padding: 10px;
    border-top: 1px solid #dee2e6;
} 

#byReceipt .form-label-group {
    margin-bottom: 10px;
}

.form-control.date-picker {
	height: 3.125rem;
}

.section-header {
    padding: 10px;
    height: 50px;
    margin-bottom: 0px;    
}

.vertical-fix {
    display: inline-block;
    margin-top: 3px;
}
</style>
